import { FC, useState, useEffect, useMemo } from 'react';
import {
    Card,
    CardContent,
    Grid,
    CardHeader,
    Typography,
    Divider,
    FormControlLabel,
    Checkbox,
    Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUICustomerCardModal } from '../../../../../atomic/atoms';
import Swal from 'sweetalert2';
import { RefundRestQuery } from '../../../../../services/query';
import { enumRefundStatusType } from '../../../../../types/enums/status';
import Helper from '../../../../../utils/helper';
import { PaymentCommand } from '../../../../../services/command';
import { CloseRefundRecordButton } from '../CloseRefundRecordButton/CloseRefundRecordButton';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';

export const RefundWaitingPayment: FC<{
    currencySymbol?: any;
    orderId: any;
    returnId?: any;
    returnDatas?: any;
    customerId?: any;
    refundId?: any;
    refundDetails?: any;
    orderDate?: any;
    refundDetailId?: any;
    customerChoiceBankAccountId?: any;
    getRefundDetails?: any;
}> = ({
    currencySymbol,
    orderId,
    returnId,
    returnDatas,
    customerId,
    refundId,
    refundDetails,
    orderDate,
    customerChoiceBankAccountId,
    getRefundDetails,
}) => {
    const { t } = useTranslation();
    const [bankAccount, setBankAccount] = useState<any>();
    const [showManuelField, setShowManuelField] = useState<any>();
    const [showLcwMoneyDisplay, setShowLcwMoneyDisplay] = useState<any>();
    const unClosedRefundInitial = useMemo(() => {
        return (
            refundDetails &&
            refundDetails.entity.refundDetails.filter(
                (city: any) => city.refundDetailStatusId === 1 || city.refundDetailStatusId === 3
            )
        );
    }, [refundDetails]);
    const [unClosedRefund, setUnClosedRefund] = useState<any>();
    const [manuelMethodId, setManuelMethodId] = useState(0);
    const refundStatus = refundDetails && enumRefundStatusType[refundDetails.entity.refundStatusId];
    const handleCheckboxChange = (Item: any) => () => {
        setManuelMethodId(Item);
    };
    const onModalOpen = () => setModalOpen(true);
    const onModalClose = () => setModalOpen(false);
    const [modalOpen, setModalOpen] = useState(false);

    const GetBankAccountByCustomerBankAccountId = async () => {
        let params: any = {
            customerBankAccountId: customerChoiceBankAccountId,
        };
        PaymentCommand.GetBankAccountByCustomerBankAccountId(params).then((res: any) => {
            console.info('res', res);
            if (res) {
                setBankAccount(res.bankAccount);
            }
        });
    };
    const GetRefundPageRuleFromServiceForLcwMoney = () => {
        RefundRestQuery.GetRefundPageRuleFromServiceForLcwMoney()
            .then((res: any) => {
                if (res.data) {
                    setShowLcwMoneyDisplay(res.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    useEffect(() => {
        GetRefundPageRuleFromServiceForLcwMoney();
        if (customerChoiceBankAccountId) {
            GetBankAccountByCustomerBankAccountId();
        }
        checkOperatorFromRuleService();
    }, []);
    const processRefunds = (refunds: any) => {
        if (refunds) {
            // bekleyen ödemelerde refundDetailStatusId 1 ve "refundMethodId": 1 ve consolidatedOrderId 0 dan farklı ise olanları toplayıp göster tek seferde göster

            // İki farklı durumu birleştirmek için boş bir dizi oluşturuyoruz.
            let mergedRefunds: any = [];
            let otherRefunds: any = [];

            refunds.forEach((refund: any) => {
                if (
                    refund.refundDetailStatusId === 1 &&
                    refund.refundMethodId === 1 &&
                    refund.consolidatedOrderId &&
                    refund.consolidatedOrderId > 0
                ) {
                    mergedRefunds.push(refund);
                } else {
                    otherRefunds.push(refund);
                }
            });

            for (let i = 1; i < mergedRefunds.length; i++) {
                mergedRefunds[0].amountRefunded += mergedRefunds[i].amountRefunded;
            }

            mergedRefunds.splice(1);
            // mergedRefunds dizisindeki iadelerin amountRefunded özelliğini topluyoruz.
            // Toplam iade miktarını son iadeye ekliyoruz
            // Diğer iadeleri mergedRefunds dizisine ekliyoruz.
            mergedRefunds = mergedRefunds.concat(otherRefunds);
            // State'i güncelliyoruz.
            setUnClosedRefund(mergedRefunds);
        }
    };

    useEffect(() => {
        processRefunds(unClosedRefundInitial);
    }, [unClosedRefundInitial]);

    const SendUnmatchedIbanMessage = async () => {
        RefundRestQuery.ConvertPaybackToLcwMoney({
            customerId: customerId,
            refundId: refundId,
        }).then(() => {
            Swal.fire(t('customerInformation.sendSMSText'), ' ', 'success');
            window.location.reload();
        });
    };

    const UpdateWireRefundCustomerChoice = (selectedBankAccount: any) => {
        RefundRestQuery.UpdateWireCustomerChoice({
            refundId: refundId,
            NewWireBankAccountId: selectedBankAccount.bankAccountId,
            orderDate: orderDate ? orderDate : null,
        }).then(() => {
            Swal.fire(t('general.completed'), ' ', 'success');
            window.location.reload();
        });
    };
    const RefundWarning = () => (
        <Grid
            width={600}
            style={{
                color: 'orange',
                backgroundColor: '#fff3e0',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <WarningIcon style={{ color: 'orange', marginRight: 8 }} />
            <Typography variant="body1">{t('refund.refundShouldEnd')}</Typography>
        </Grid>
    );
    const PartialReturnWarning = () => (
        <Grid
            width={600}
            style={{
                color: 'orange',
                backgroundColor: '#fff3e0',
                padding: '16px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <WarningIcon style={{ color: 'orange', marginRight: 8 }} />
            <Typography variant="body1">{getRefundDetails?.entity?.refundDetails[0]?.description}</Typography>
        </Grid>
    );

    const renderAmountWithCurrency = (amount: number) => {
        return `${Helper.formatNumber(amount)} ${currencySymbol}`;
    };
    const checkOperatorFromRuleService = () => {
        RefundRestQuery.CheckOperatorFromRuleService().then((res: any) => {
            if (res) {
                setShowManuelField(res.data);
            }
        });
    };
    return (
        <Grid container sx={{ paddingLeft: '3rem' }}>
            {modalOpen && (
                <SCUICustomerCardModal
                    open={modalOpen}
                    callFunction={UpdateWireRefundCustomerChoice}
                    onClose={onModalClose}
                    customerId={customerId}
                    buttonText={t('refund.updateCalculation')}
                />
            )}
            <Card style={{ width: '100%' }}>
                <CardHeader
                    title={
                        <Typography noWrap gutterBottom variant="h6" component="h4">
                            <b>{t('refund.paymentInfo')}</b>
                        </Typography>
                    }
                />
                <Divider />
                <CardContent>
                    {!refundDetails?.isEnableCloseRefundShowed &&
                        unClosedRefund &&
                        unClosedRefund.some((item: any) => item.refundMethodId === 1) && <RefundWarning />}
                    <br />
                    {(getRefundDetails.entity.countryId === 125 || getRefundDetails.entity.countryId === 138) &&
                        getRefundDetails.entity.refundDetails[0]?.description?.length > 0 && <PartialReturnWarning />}

                    <CloseRefundRecordButton
                        refundId={refundId}
                        orderId={orderId}
                        returnId={returnId}
                        customerId={customerId}
                        refundDetails={refundDetails}
                        orderDate={orderDate}
                        returnDatas={returnDatas}
                        manuelMethodId={manuelMethodId}
                    />
                    {unClosedRefund &&
                        unClosedRefund.map((Item: any, index: number) => (
                            <>
                                <Grid
                                    size={{
                                        md: 12,
                                        xs: 12,
                                    }}
                                    sx={{ mt: index === 0 ? 2 : 0 }}
                                >
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {Helper.getPaymentName(Item.refundMethodId, Item.refundWalletType)}
                                    </Typography>
                                </Grid>
                                {Item.refundMethodId === 1 && bankAccount && bankAccount !== null && (
                                    <>
                                        {bankAccount.bankName && (
                                            <Grid
                                                size={{
                                                    md: 12,
                                                    xs: 12,
                                                }}
                                            >
                                                <label>
                                                    <b>{t('refund.bankName')}: </b>
                                                    {bankAccount.bankName}
                                                    {bankAccount.bankImageUrl && (
                                                        <img
                                                            src={bankAccount.bankImageUrl}
                                                            alt="Bank Logo"
                                                            style={{ width: '80px' }}
                                                        />
                                                    )}
                                                </label>
                                            </Grid>
                                        )}
                                        <Grid
                                            size={{
                                                md: 12,
                                                xs: 12,
                                            }}
                                        >
                                            {bankAccount.accountOwner && (
                                                <label>
                                                    <b>{t('refund.accountName')}: </b>
                                                    {bankAccount.accountOwner}
                                                </label>
                                            )}
                                            <Grid
                                                size={{
                                                    md: 12,
                                                    xs: 12,
                                                }}
                                            >
                                                {bankAccount.accountNumber && (
                                                    <label>
                                                        <b>{t('refund.accountNumber')}: </b>
                                                        {bankAccount.accountNumber}
                                                    </label>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            size={{
                                                md: 12,
                                                xs: 12,
                                            }}
                                        >
                                            {bankAccount.ibanNumber && (
                                                <label style={{ display: 'flex', alignItems: 'center' }}>
                                                    <b>IBAN : </b>&nbsp;
                                                    <div
                                                        style={{
                                                            color: bankAccount.isIBANValid ? 'inherit' : 'red',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        {bankAccount.ibanNumber}
                                                        {!bankAccount.isIBANValid && (
                                                            <Tooltip title={t('refund.wrongIBAN')} placement="top">
                                                                <CancelIcon style={{ color: 'red' }} />
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                </label>
                                            )}
                                        </Grid>
                                    </>
                                )}
                                {!Helper.isStoreEmployeeForFrontend() && Item.refundMethodId === 2 && (
                                    <>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('refund.automatic')}
                                            name={Item.refundDetailId}
                                            checked={manuelMethodId === 0}
                                            onChange={handleCheckboxChange(0)}
                                        />
                                        {showManuelField && (
                                            <FormControlLabel
                                                control={<Checkbox />}
                                                label={t('refund.manual')}
                                                name={Item.otherCheckboxId}
                                                checked={manuelMethodId === 2}
                                                onChange={handleCheckboxChange(2)}
                                            />
                                        )}
                                    </>
                                )}
                                <Grid
                                    size={{
                                        md: 12,
                                        xs: 12,
                                    }}
                                >
                                    <Typography variant="subtitle1">
                                        <b>{t('refund.amount')} : </b>
                                        {renderAmountWithCurrency(Item.amountRefunded)}
                                    </Typography>
                                </Grid>
                                <Grid container direction="row" spacing={1} sx={{ mt: 2 }}>
                                    {refundStatus === 'IncludedToPetition' &&
                                        (Item.refundMethodId === 1 || Item.refundMethodId === 3) && (
                                            <>
                                                <Grid
                                                    size={{
                                                        xl: 3,
                                                        lg: 6,
                                                        md: 12,
                                                        xs: 12,
                                                    }}
                                                >
                                                    <SCUIButton
                                                        text={t('refund.enterBankInfo')}
                                                        type="primary"
                                                        sizeType="fixed"
                                                        size={'l'}
                                                        buttonType="button"
                                                        onClick={() => onModalOpen()}
                                                    />
                                                </Grid>
                                                {/* {visibleLCWMoney && <Grid item xl={3} lg={3} md={12} xs={12}><SCUIButton  text={ "LCW Para Tanımla"}  type="primary"  sizeType="fixed" size={"l"} buttonType="button"   onClick={()=>refundReason==="Return" ?CompleteAndConfirmWalletTransaction():ConvertRefundToWalletTransaction()}/> </Grid>}   */}
                                                {showLcwMoneyDisplay?.showLcwMoney && (
                                                    <Grid
                                                        size={{
                                                            xl: 3,
                                                            lg: 6,
                                                            md: 12,
                                                            xs: 12,
                                                        }}
                                                    >
                                                        <SCUIButton
                                                            text={t('refund.dismatchingIBAN')}
                                                            type="primary"
                                                            sizeType="fixed"
                                                            size={'l'}
                                                            buttonType="button"
                                                            onClick={() => SendUnmatchedIbanMessage()}
                                                        />
                                                    </Grid>
                                                )}
                                            </>
                                        )}
                                    {refundStatus !== 'IncludedToPetition' &&
                                        (Item.refundMethodId === 1 || Item.refundMethodId === 3) && (
                                            <>
                                                <Grid
                                                    size={{
                                                        xl: 3,
                                                        lg: 6,
                                                        md: 12,
                                                        xs: 12,
                                                    }}
                                                >
                                                    <SCUIButton
                                                        text={t('refund.enterBankInfo')}
                                                        type="primary"
                                                        sizeType="fixed"
                                                        size={'l'}
                                                        buttonType="button"
                                                        onClick={() => onModalOpen()}
                                                    />
                                                </Grid>
                                                {/* {visibleLCWMoney && <Grid item xl={3} lg={3} md={12} xs={12}><SCUIButton  text={ "LCW Para Tanımla"}  type="primary"  sizeType="fixed" size={"l"} buttonType="button"   onClick={()=>refundReason==="Return" ?CompleteAndConfirmWalletTransaction():ConvertRefundToWalletTransaction()}/> </Grid>}  */}

                                                {showLcwMoneyDisplay?.showLcwMoney && (
                                                    <Grid
                                                        size={{
                                                            xl: 3,
                                                            lg: 6,
                                                            md: 12,
                                                            xs: 12,
                                                        }}
                                                    >
                                                        <SCUIButton
                                                            text={t('refund.dismatchingIBAN')}
                                                            type="primary"
                                                            sizeType="fixed"
                                                            size={'l'}
                                                            buttonType="button"
                                                            onClick={() => SendUnmatchedIbanMessage()}
                                                        />
                                                    </Grid>
                                                )}
                                            </>
                                        )}
                                </Grid>
                                <Divider sx={{ paddingBottom: 1 }} />
                                <br />
                            </>
                        ))}
                </CardContent>
            </Card>
        </Grid>
    );
};
